import { Injectable } from "@angular/core";

import {
  OrdersTableDefinitionFactory,
  ActiveUserProfilePromiseService,
  ClientPromiseLookupService,
  CcyPairPromiseLookupService,
  CurrencyPairGroupPromiseLookupService,
  AlgoStrategyLookupService,
  AlgoStrategyPromiseLookupService,
} from "shared/cubiq-services";
import { BfxOrderBlotterFilteringService } from "../../bfx-blotter-orders/bfx-blotter-orders-filter.service";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { BfxSysConfigUtilService } from "shared/auth-services";
import { AlgoMonitorDefinitionFactory } from "shared/cubiq-services/model/AlgoMonitorDefinitionFactory";

@Injectable()
export class BfxAlgoMonitorFilteringService extends BfxOrderBlotterFilteringService {
  constructor(
    protected tableDefinitionFactory: AlgoMonitorDefinitionFactory,
    protected activeUserService: ActiveUserProfilePromiseService,
    protected clientService: ClientPromiseLookupService,
    protected currencyPairService: CcyPairPromiseLookupService,
    protected currencyPairGroupService: CurrencyPairGroupPromiseLookupService,
    protected algoStrategyLookup: AlgoStrategyPromiseLookupService,
    protected sysConfigUtilService: BfxSysConfigUtilService,
  ) {
    super(
      tableDefinitionFactory,
      activeUserService,
      clientService,
      currencyPairService,
      currencyPairGroupService,
      algoStrategyLookup,
      sysConfigUtilService,
    );
  }
}
